'use client'
import { FC, ReactNode } from 'react'
import { DeliveryDTO, Option } from 'ecosystem'
import { useTrackPageView } from 'storefront-modules/third-party'
import { AihubAnalyticsProvider } from 'storefront-modules/aihub'
import { CustomAiHub } from '#/src/custom/components/CustomAiHub'
import { NotificationsProvider } from 'storefront-modules/notifications'

interface AppComponentProps {
  children: ReactNode
  deliveries?: Option<DeliveryDTO[]>
}

const AppComponent: FC<AppComponentProps> = ({ children, deliveries }) => {
  useTrackPageView()

  return (
    <NotificationsProvider isDebug>
      {/*
        This app has no `GTMProvider`, so `useGTMContext` yields no consent
        manager and the gate could never open. Structural, not a policy choice —
        remove this prop once the app moves to the GTMProvider setup.
      */}
      <AihubAnalyticsProvider skipConsent>
        {children}
        <CustomAiHub deliveries={deliveries} />
      </AihubAnalyticsProvider>
    </NotificationsProvider>
  )
}

export default AppComponent
